import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/checkinRewards/currency.png'


const _hoisted_1 = { class: "bannerContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "checkin_container" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "text_2" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "text_2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 2,
  class: "bottom_text"
}
const _hoisted_10 = { class: "title" }

import CustomHeader from '../components/common/customHeader.vue';
import { ref } from 'vue';
import CheckinPopup from './components/checkinPopup.vue';
import VerifyPhonePopup from './components/verifyPhonePopup.vue';
import { CheckingRewardData } from '@/view/checkinRewards/checkinRewards';


export default /*@__PURE__*/_defineComponent({
  __name: 'checkinRewards',
  props: {
    dataSet: {}
  },
  emits: ['updateInfo', "callCheckinClaim", 'goToVerifyPhoneNum'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const verifyPhoneRef = ref()

const props = __props

const emits = __emit
const checkinRef = ref()


const callCheckinClaim = (configData: any, claimType: number) => {
    emits("callCheckinClaim", configData, claimType)
}

const goToVerifyPhoneNum = (type: any) => {
    emits('goToVerifyPhoneNum', type)
}
const updateInfo = () => {
    emits('updateInfo')
}

const openVerifyPhonePopup = () => {
    verifyPhoneRef.value.open()
}

const checkinOpen = (data: any, value: any) => {
    checkinRef.value.open(data, value)
}
const checkinclose = () => {
    checkinRef.value.close()
}
__expose({
    checkinOpen,
    checkinclose,
    openVerifyPhonePopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.signin_rewards')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.dataSet.bannerIcon,
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.dataSet.hasNotVerifyData)
        ? (_openBlock(), _createBlock(_component_van_row, {
            key: 0,
            class: "claimField"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "18",
                class: "claimText"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[3] || (_cache[3] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    }, null, -1)),
                    _createTextVNode(" R$ " + _toDisplayString(_ctx.dataSet.notVerifyConfig?.reward) + " × " + _toDisplayString(_ctx.dataSet.notVerifyConfig?.days) + " " + _toDisplayString(_ctx.$t('common.days')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('activity.noPhoneVerification')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "6",
                class: "claimColumn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["click_btn", _ctx.dataSet.isPhoneVerified ? 'disableBtn' : '']),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (callCheckinClaim(_ctx.dataSet.notVerifyConfig, 1)))
                  }, _toDisplayString(_ctx.$t('activity.claim')), 3)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.dataSet.isShowPhoneVerification && _ctx.dataSet.hasVerifyPhoneData)
        ? (_openBlock(), _createBlock(_component_van_row, {
            key: 1,
            class: "claimField"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "18",
                class: "claimText"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[4] || (_cache[4] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    }, null, -1)),
                    _createTextVNode(" R$ " + _toDisplayString(_ctx.dataSet.verifyConfig.reward) + " × " + _toDisplayString(_ctx.dataSet.verifyConfig.days) + " " + _toDisplayString(_ctx.$t('common.days')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('activity.phoneVerification')) + " ", 1),
                    (_ctx.dataSet.isPhoneVerified)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('activity.verified')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "6",
                class: "claimColumn"
              }, {
                default: _withCtx(() => [
                  (_ctx.dataSet.isPhoneVerified)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "click_btn",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (callCheckinClaim(_ctx.dataSet.verifyConfig, 2)))
                      }, _toDisplayString(_ctx.$t('activity.claim')), 1))
                    : _createCommentVNode("", true),
                  (!_ctx.dataSet.isPhoneVerified)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "click_btn",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (goToVerifyPhoneNum(0)))
                      }, _toDisplayString(_ctx.$t('activity.verify')), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.dataSet.activityInfo.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('common.activityTitle')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "line_text",
                key: index
              }, _toDisplayString(item), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(VerifyPhonePopup, {
      ref_key: "verifyPhoneRef",
      ref: verifyPhoneRef,
      onUpdateInfo: updateInfo
    }, null, 512),
    _createVNode(CheckinPopup, {
      ref_key: "checkinRef",
      ref: checkinRef,
      onGoToVerify: goToVerifyPhoneNum
    }, null, 512)
  ], 64))
}
}

})